/*
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2020-03-26 20:15:03
 * @LastEditors: 南岸有归
 * @Description: 
 * @FilePath: \cloud_frontend\src\views\system\Authoritymanagement\TableConfig.js
 * @
 */
import i18n from "../../../common/lang";
export const Columns=[
    {LabelName:i18n.t('lang.Authoritymanagement.Character'),key:0,ColumnsKey:'roleName',seek:'roleName',placeholder:i18n.t('lang.Authoritymanagement.search1'), sort: 'custom'},
    {LabelName:i18n.t('lang.Authoritymanagement.describe'),key:1,ColumnsKey:'roleDescription',seek:'roleDescription',placeholder:i18n.t('lang.Authoritymanagement.search2'), sort: 'custom'},
    {LabelName:i18n.t('lang.Authoritymanagement.statevoid'),key:2,align: 'center',row: 150,ColumnsKey:'normal',seek:'normal',placeholder:i18n.t('lang.Authoritymanagement.search3'),Tag:true,Fun:'GetStatus', sort: 'custom'},
    {LabelName:i18n.t('lang.Authoritymanagement.Creator'),key:3,ColumnsKey:'userNickname',seek:'userNickname',placeholder:i18n.t('lang.Authoritymanagement.search4'), sort: 'custom'},
    {LabelName:i18n.t('lang.Authoritymanagement.belonging'),key:4,ColumnsKey:'c_name',seek:'c_name',placeholder:i18n.t('lang.Authoritymanagement.search5'),Fun:'GetCname', sort: 'custom'},
    {LabelName:i18n.t('lang.Authoritymanagement.Creation'),key:5,ColumnsKey:'roleCreate',seek:'roleCreate',placeholder:i18n.t('lang.Authoritymanagement.search6'), sort: 'custom'},
]

export const ColuumnsButton=[
    {key:0,type:'primary',icon:'icon-mingpian',Fun:'setroleIdsetjurisdiction',Authority:24},
    {key:1,type:'danger',icon:'el-icon-delete',Fun:'deleteRole',Delete:true,Authority:25}
]
